import jwt from '../../http/requests/auth/jwt/index.js';

import 'firebase/auth';
import router from '@/router';
import axios from '@/axios';

export default {
  // JWT
  loginJWT({commit}, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .login(payload.userDetails.email, payload.userDetails.password)
        .then((response) => {
          // If there's user data in response
          if (response.data) {
            // Navigate User to homepage
            router.push('/admin/dashboard');
            localStorage.setItem(
              'user',
              JSON.stringify(response.data.data.user)
            );
            localStorage.setItem('firstName', response.data.data.firstName);
            localStorage.setItem(
              'refreshToken',
              response.data.data.token.refreshToken
            );
            var date = new Date().getTime() + 60 * 60 * 24 * 1000;
            localStorage.setItem('tokenExpiry', date);
            localStorage.setItem('loggedIn', 'true');
            // Set accessToken
            localStorage.setItem(
              'accessToken',
              response.data.data.token.accessToken
            );

            // Update user details
            commit('UPDATE_USER_INFO', response.data.data, { root: true });
            // Set bearer token in axios
            commit('SET_BEARER', response.data.data.token.accessToken);

            resolve(response);
          } else {
            reject({ message: response.data.msg });
          }
        })
        .catch(({ response }) => {
          reject({ message: response.data.msg });
        });
    });
  },
  registerUserJWT(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .registerClinic(payload.userDetails)
        .then((response) => {
          // Redirect User
          router.push(router.currentRoute.query.to || '/');
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  checkEmail(_context, email) {
    return new Promise((resolve, reject) => {
      jwt
        .checkEmailAvailability(email)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDoctors(_context, data) {
    return new Promise((resolve, reject) => {
      let fetchDoctorUrl =
        '/api/v1/doctors/userManagement/doctors?page=' +
        data.page +
        '&limit=' +
        data.limit +
        '&search=' +
        encodeURIComponent(data.search) +
        '&sort=' +
        data.sort +
        '&dir=' +
        data.dir +
        '&userType=' +
        data.userType +
        '&filter=' +
        data.filter +
        '&activeClinicId=' +
        data.activeClinicId;
      if (data.franchiseId) {
        fetchDoctorUrl += '&franchiseId=' + data.franchiseId;
      }
      axios
        .get(fetchDoctorUrl)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchClinicEMRDoctors(_context, data) {
    return new Promise((resolve, reject) => {
      let fetchDoctorUrl =
        '/api/v1/doctors/userManagement/emr-doctors?page=' +
        data.page +
        '&limit=' +
        data.limit +
        '&search=' +
        data.search +
        '&sort=' +
        data.sort +
        '&dir=' +
        data.dir +
        '&userType=' +
        data.userType +
        '&filter=' +
        data.filter +
        '&clinicId=' +
        data.clinicId;
      axios
        .get(fetchDoctorUrl)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchAssignEmrClinics(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/doctors/emr-doctor/clinics/assign/list', { params: {id: id} })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchDoctorEMRClinics(_context, data) {
    return new Promise((resolve, reject) => {
      let fetchDoctorUrl =
        '/api/v1/doctors/emr-doctor/'+data.doctorId+'/clinics/list?page=' +
        data.page +
        '&limit=' +
        data.limit +
        '&search=' +
        data.search +
        '&sort=' +
        data.sort +
        '&dir=' +
        data.dir +
        '&filter=' +
        data.filter;
      axios
        .get(fetchDoctorUrl)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchSuburbs(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/getSuburbs', { params: data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchAuthorizingDoctors() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/authorizingDoctors')
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchDoctorDetail(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/doctors/userManagement/doctors/' + id)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  updateDoctorDetail(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/userManagement/doctors/' + data.id, data.data)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  deleteDoctor(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v1/doctors/userManagement/doctor/' + id)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  removeAssignedClinic(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v1/doctors/directorAssignedClinic', { params: { assignedClinicId: data } })
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  resetDoctorPassword(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/doctors/userManagement/doctors/' +
          data.id +
          '/resetPassword',
          data.data
        )
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  createDoctor(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/userManagement/doctors/create', data.userDetails)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  fetchPatients(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/doctors/patients', { params: data })
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },

  fetchDoctorTreatmentHistory(_context, data) {
    if (!data.datatableOptions.dir) {
      data.datatableOptions.dir = 'desc';
      data.datatableOptions.sort = 'appointmentDate';
    }

    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/doctors/userManagement/doctors/' +
          data.doctorId +
          '/treatment-history',
          { params: data.datatableOptions }
        )
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },

  fetchEmrPatientsListFilter(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/doctors/patients/list-filter/emr',
          { params: {
            clinicId: data.clinicId,
            isAllPatients: 1,
            limit: data.limit,
            sortBy: 'alphabetical',
          } }
        )
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  searchEmrPatientsListFilter(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/doctors/patients/searchPatientByName',
          { params: {
            fullName: data.search,
            clinicId: data.clinicId,
            limit: data.limit,
            page: data.page || 1,
            type: 'nurse',
          } }
        )
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  fetchDoctorRoleTreatmentHistory(_context, data) {
    if (!data.datatableOptions.dir) {
      data.datatableOptions.dir = 'desc';
      data.datatableOptions.sort = 'appointmentDate';
    }

    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/doctors/userManagement/doctors/role/' +
          data.doctorId +
          '/treatment-history',
          { params: data.datatableOptions }
        )
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  fetchDoctorRoleOnCallTreatmentHistory(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/doctors/role/treatment/log',
          { params: data }
        )
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  fetchDoctorOnCallTreatmentHistory(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/doctors/treatment/log',
          { params: data }
        )
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  exportCsv(_context, data) {
    return new Promise((resolve, reject) => {
      // Encode special characters in the query to make it safe for URLs and prevent breaking the API request
      const encodedSearchQuery = encodeURIComponent(data.search);
      axios
        .post(
          '/api/v1/doctors/userManagement/doctors/export-csv?page=' + data.page +
          '&limit=' + data.limit +
          '&exportMode=' + data.exportMode +
          '&clinicId=' + data.clinicId +
          '&isDoctorEmr=' + data.isDoctorEmr +
          '&search=' + encodedSearchQuery +
          '&filter=' + data.filter
        )
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  docEmrSendAfterCareEmail(_context, data) {
    return axios.get(`/api/v2/doctors/appointments/${data.appointmentId}/send-aftercare-pdf`, {params: data.params});
  },
  docEmrgenerateAfterCareEmail(_context, data) {
    return axios.get(`/api/v2/doctors/appointments/${data}/generate-aftercare-pdf`);
  },
  createNewEMRTreatment(_context, data) {
    return axios.post('/api/v2/doctors/appointments', data);
  },
  getUserEMRclinics(_context, data) {
    return axios.get('/api/v1/doctors/emr-clinics/list', {params: data});
  },
  assignEmrDoctor(_context,data) {
    return axios.put(`/api/v1/doctors/userManagement/emr-doctors/assign/${data.clinicId}`,{'userIds':data.userId});
  },
  assignEmrClinics(_context,data) {
    return axios.put(`/api/v1/doctors/userManagement/emr-doctors/assign/clinics/${data.userId}`,{'clinicIds':data.clinicIds});
  },
  removeEmrDoctor(_context,data) {
    return axios.put(`/api/v1/doctors/userManagement/remove/emr-doctor/${data.clinicId}`,{'userId':data.userId});
  },
  fetchUnassignedEMRDoctors(_context, clinicId) {
    return axios.get('/api/v1/doctors/emr-doctors'+'?clinicId='+clinicId);
  },
  getDoctorDashboardData() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/doctors/dashbaordData')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  respondClinicJoinRequest(_context, params) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/acceptRejectClinicJoinRequest', params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchTreatmentHistory(_context, params) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/getAllTreatmentHistories', params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  signAndSend(_context, params) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/signAndSend', params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  sendMonthlyReportToAdmin(_context, params) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/sendMonthlyReport', params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  signAndSendWeek(_context, params) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/signAndSend', params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchNurseDoctors(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/doctors/userManagement/nurseDoctors', { params: data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  saveDoctorBankDetails({commit}, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/bankDetails/create', data)
        .then((res) => {
          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}FirstName`,
            res.data.data.firstName
          );

          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`,
            JSON.stringify(res.data.data)
          );

          commit('UPDATE_USER_INFO', res.data.data, { root: true });
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchTreatmentOutcomesList(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/doctors/treatmentOutcome/history/' + id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateDoctorBankDetails(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/bankDetails/edit', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchPostPhotoHistoryList(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/doctors/treatmentPhoto/history/' +
          data.id +
          '?value=' +
          data.isBeforePhoto
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateDoctorRoles(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/toggleDoctorRoles', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateAssignedClinicMedicalDoctor(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/assignDirectorsClinic', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchSupervisedUsers(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/doctors/supervisedUsers/?doctorId=' +
          data.doctorId
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchAssignedMedicalDoctor(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/doctors/directorAssignedClinic/?doctorId=' + data.doctorId
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchDoctorTreatmentPlans(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/doctors/treatmentPlan/findProduct', { params: data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateAppointmentTreatmentPlans(_context, {appointmentId, treatmentPlans}) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/v2/doctors/appointments/${appointmentId}/treatmentplans`, {treatmentPlans})
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
